module.exports = __webpack_public_path__ + "assets/img/1093.3c4413a8.png";